import { render, staticRenderFns } from "./tohitcards.vue?vue&type=template&id=b4e52870&scoped=true&"
import script from "./tohitcards.vue?vue&type=script&lang=js&"
export * from "./tohitcards.vue?vue&type=script&lang=js&"
import style0 from "./tohitcards.vue?vue&type=style&index=0&id=b4e52870&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e52870",
  null
  
)

export default component.exports